import type { PageConfig } from 'src/libs/PageConfig';

import type { IJobApplication } from '../../../stores/JobApplicationStore/JobApplication';
import type { Bucket } from '../../../stores/JobApplicationStore/types';
import type { IStore } from '../../../stores/Store';
import { getByName } from '../../../utils/queryParams';

const getEasyAccessApplication = (
  store: IStore,
  addCustomError: PageConfig['dataDogRum']['addCustomError'],
): IJobApplication | undefined => {
  const {
    jobApplications,
    bucket,
  }: {
    jobApplications: IJobApplication[];
    bucket: Bucket;
  } = store.jobApplicationStore;
  const prospectId = getByName('prospect');
  const jobApplication = jobApplications.find(
    (application) => application.id === prospectId,
  );

  if (prospectId !== '' && typeof jobApplication === 'undefined') {
    const jobApplicationIds = jobApplications.map((app) => app.id);
    addCustomError({
      error: 'EASY_ACCESS',
      context: {
        description: 'Cannot find prospect ID within job applications',
        bucket,
        prospectId,
        jobApplicationIds,
        positionId: store.positionId,
      },
    });
  }

  return jobApplication;
};

export default getEasyAccessApplication;
